import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './AdminApp';
import logo from './assets/adminlogo.png';

const favicon = document.getElementById('app-favicon');
if (favicon) favicon.href = logo;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
